import { Component, OnInit } from '@angular/core';

// -----------------------------------------------------------------
// LIBRARIES/LIBRERIAS
// -----------------------------------------------------------------
import * as XLSX from 'xlsx';
import * as _ from 'lodash';

// -----------------------------------------------------------------
// SERVICES/SERIVICIOS
// -----------------------------------------------------------------
import { GeneralService } from '../../../services/general/general.service';


@Component({
  selector: 'app-masive-registration-csv',
  templateUrl: './masive-registration-csv.component.html',
  styleUrls: ['./masive-registration-csv.component.css']
})
export class MasiveRegistrationCsvComponent implements OnInit {

    // -----------------------------------------------------------------
    // ATTRIBUTES/ATRIBUTOS
    // -----------------------------------------------------------------
    hideLoad: boolean;
    header: any;
    lines: any[];

  constructor(
      private func: GeneralService
  ) { }

  ngOnInit() {
  }

  changeListener($event): void {
    this.readThis($event.target);
}

readThis(inputValue: any): void {
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();
    var rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer

    let str = file.name.split('.').pop()

    myReader.onloadend = (e) => {
        // YOU CAN PERFORM AN ACTION WITH READED DATA HERE
        if (str !== 'xlsx' && str !== 'XLSX') {
            // this.toast.pop('error', null, 'El archivo elegido no corresponde con un documento de Excel')
        } else {
            this.hideLoad = true;

            var data = myReader.result;
            if (!rABS) {
                let d = new Uint8Array(data)
                var workbook = XLSX.read(d, { type: rABS ? 'binary' : 'array' });
            } else {
                var workbook = XLSX.read(data, { type: rABS ? 'binary' : 'array' });
            }

            console.log(workbook)

            var sheet_name_list = workbook.SheetNames;
            sheet_name_list.forEach(y => {
                var worksheet = workbook.Sheets[y];
                var headers = {};
                var data: Array<any> = [];
                var z
                for (z in worksheet) {
                    if (z[0] === '!') continue;
                    //parse out the column, row, and value
                    var col = z.substring(0, 1);
                    var row = parseInt(z.substring(1));
                    var value = worksheet[z].v;

                    //store header names
                    if (row == 1) {
                        headers[col] = value;
                        continue;
                    }

                    if (!data[row]) {
                        data[row] = {} as any;
                    }
                    data[row][headers[col]] = value;
                }

                //drop those first two rows which are empty
                data.shift();
                data.shift();

                let temp_data: Array<any> = []

                // agregando las cabeceras en la variable de cabeceras
                _.values(headers).forEach(v => { this.header.push(v); })
                // agregando los datos de los usuarios en la variable de datos
                data.forEach(r => {
                    temp_data.push(_.values(r))
                });
                this.lines = temp_data
                this.nextStep()
            });
        }
    }
    if (rABS) myReader.readAsBinaryString(file); else myReader.readAsArrayBuffer(file);
}

nextStep() {
    // HASTA ESTE PUNTO LINES TIENE CADA ROW DEL ARCHIVO CSV
    // OBTENIENDO LA CABECERA DEL ARCHIVO
    if (this.lines.length >= 1) {
        // REMOVING EMPTY STRINGS FROM HEADER
        this.header = this.header.filter(function (n) { return n != '' });
        // this.toast.pop('info', 'Bien', 'Los datos han sido cargados con éxito')
    } else {
        this.func.emptyArray(this.header)
        this.func.emptyArray(this.lines)
        this.hideLoad = false
        // this.toast.pop('warning', 'Disculpe', 'No hay datos en el archivo propocionado.')
    }
}

uploadFile(event) {
    let reader = new FileReader()
    // obtengo el archivo
    const file = event.target.files[0];

    // verifico el tipo
    let str = file.name.split('.')
    str = str.pop()

    if (str !== 'xlsx' && str !== 'XLSX') {
        // this.toast.pop('error', null, 'El archivo elegido no corresponde con un documento de Excel')
    } else {
        // hides the load input
        this.hideLoad = true;

        // Read file into memory as UTF-8
        reader.readAsText(file);

        // Handle errors load
        reader.onload = () => {
            var csv = reader.result;
            var allTextLines = csv.split(/\r\n|\n/);

            for (var i = 0; i < allTextLines.length; i++) {
                var data = allTextLines[i].split(',');
                var tarr = [];
                for (var j = 0; j < data.length; j++) {
                    tarr.push(String(data[j]));
                }
                this.lines.push(tarr);
            }
        }

        reader.onloadend = () => {
            // hasta este punto lines tiene cada row del archivo csv
            // obteniendo la cabecera del archivo
            if (this.lines.length > 1) {
                this.header = this.lines[0]

                // removing empty strings from header
                this.header = this.header.filter(function (n) { return n != '' });
                this.lines.shift()
                this.lines.pop()
                // console.log(this.header)
                // console.log(this.lines)

                // this.toast.pop('info', 'Bien', 'Los datos han sido cargados con éxito')
            } else {
                this.func.emptyArray(this.header)
                this.func.emptyArray(this.lines)

                this.hideLoad = false
                // this.toast.pop('warning', 'Disculpe', 'No hay datos en el archivo propocionado.')
            }

        }
    }
}

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/masive-registration-csv/masive-registration-csv.component.ts